export default "__VITE_ASSET__c240c835__"